const actions = {
  SET_STATE: 'family/SET_STATE',
  SESSION_RELATIONS: 'family/SESSION_RELATIONS',
  FAMILY_DETAILS: 'family/FAMILY_DETAILS',
  CREATE_NEW: 'family/CREATE_NEW',
  EDIT_MEMBER: 'family/EDIT_MEMBER',
  DELETE_MEMBER: 'family/DELETE_MEMBER',
}

export default actions
